import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { axios, errorResponse } from "../../../helpers";
import { loginData, logout } from "../../../stores/auth";

const usePut = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataLogin = useSelector(loginData);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const handlePut = async (params) => {
    setIsLoading(true);
    setError("");
    setIsSuccess(false);

    try {
      const response = await axios.put(params.url, params.form, {
        headers: {
          Authorization: `Bearer ${dataLogin.data.token}`,
          "Content-Type": params.type ?? "application/json",
        },
      });

      if (response?.data?.status || response?.data?.success) {
        setIsSuccess(true);

        if (params.navigation) {
          navigate(params.navigation, { replace: true });
        }

      } else {
        const errMsg =
          response?.data?.message || "Failed to update data";
        setError(errMsg);
      }

    } catch (err) {
      if (errorResponse(err) === "jwt expired") {
        dispatch(logout());
        return;
      }

      setError(errorResponse(err) || "Unexpected error");

    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    isSuccess,
    handlePut,
  };
};

export default usePut;
